import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Recognize } from "./components/sections/Recognize";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { About } from "./components/sections/About";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ikr0e3urxc7u">
      <MetaPixel data-id="element-1" data-mp="3ml13n8r6loj0" />
      <Hero data-id="element-2" data-mp="3mkhm3t5g125i" />
      <main data-id="element-3" data-mp="3mk83iqmq9x9u">
        <Problem data-id="element-4" data-mp="3mjq2lgp4euvl" />
        <BeforeAfter data-id="element-5" data-mp="3mj6hxs835sdv" />
        <Recognize data-id="element-6" data-mp="3rcj846sey78q" />
        <Volumes data-id="element-7" data-mp="3rbzpsoyupgu6" />
        <Tools data-id="element-8" data-mp="3rdkkqfp2v1sk" />
        <Bonuses data-id="element-9" data-mp="3rd18nfm3z7mg" />
        <Offer data-id="element-10" data-mp="3relvsk63foaa" />
        <Guarantee data-id="element-11" data-mp="5orh0l86u6j" />
        <Testimonials data-id="element-12" data-mp="680frswe88f" />
        <About data-id="element-13" data-mp="5gfrc0u9uwx" />
        <Faq data-id="element-14" data-mp="82lr78302d1" />
        <FinalCta data-id="element-15" data-mp="7stfczkdj46" />
      </main>
      <Footer data-id="element-16" data-mp="2zllijblcf2rh" />
      <FloatingCta data-id="element-17" data-mp="2zm4xcjfp5b1a" />
      <PurchasePopup data-id="element-18" data-mp="2zmo7vf30ox5a" />
    </div>;
}